export default "__VITE_ASSET__2e8c1846__"